import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <rect width='24' height='24' rx='4' fill='#9D9BA7' />
                <rect x='4.00049' y='6.00006' width='16' height='12.6667' fill='white' />
                <path
                    d='M23.543 1.89143C23.7406 2.08903 23.8526 2.3558 23.8526 2.63574V22.9462C23.8526 23.5291 23.3816 24 22.7987 24H1.72088C1.13795 24 0.666992 23.5291 0.666992 22.9462V-4.45496C0.666992 -5.03789 1.13795 -5.50885 1.72088 -5.50885H15.708C15.9879 -5.50885 16.258 -5.39687 16.4556 -5.19927L23.543 1.89143V1.89143ZM21.422 3.11987L15.2238 -3.07832V3.11987H21.422ZM8.63703 10.4642C8.63703 10.642 8.78194 10.777 8.95978 10.777H10.0268C10.2047 10.777 10.3496 10.6387 10.3496 10.4674C10.3496 9.53871 11.1993 8.76805 12.2598 8.76805C13.3202 8.76805 14.1699 9.53871 14.1699 10.4642C14.1699 11.2974 13.4783 12.0186 12.5463 12.1405C11.9107 12.2327 11.4101 12.8091 11.4035 13.4612V14.515C11.4035 14.6962 11.5517 14.8444 11.7328 14.8444H12.7867C12.9679 14.8444 13.1161 14.6962 13.1161 14.515V14.1132C13.1161 13.9156 13.2478 13.7345 13.4355 13.6752C14.9044 13.201 15.9056 11.8968 15.8825 10.418C15.8562 8.59021 14.2622 7.0983 12.3092 7.07195C10.287 7.0489 8.63703 8.57374 8.63703 10.4642ZM12.2598 17.9402C12.5393 17.9402 12.8073 17.8291 13.005 17.6315C13.2026 17.4339 13.3137 17.1658 13.3137 16.8863C13.3137 16.6068 13.2026 16.3387 13.005 16.1411C12.8073 15.9434 12.5393 15.8324 12.2598 15.8324C11.9803 15.8324 11.7122 15.9434 11.5146 16.1411C11.3169 16.3387 11.2059 16.6068 11.2059 16.8863C11.2059 17.1658 11.3169 17.4339 11.5146 17.6315C11.7122 17.8291 11.9803 17.9402 12.2598 17.9402V17.9402Z'
                    fill='#9D9BA7'
                />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' rx='4' fill='white' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
